<template>
  <svg
    width="718"
    height="260"
    viewBox="0 0 718 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="718" height="259" rx="4" fill="#F2F4F7" />
    <path
      d="M394.73 118.965C394.73 116.797 394.73 115.713 394.301 115.211C393.929 114.775 393.371 114.544 392.8 114.589C392.142 114.641 391.375 115.407 389.842 116.941L376.836 129.947L389.842 142.953C391.375 144.486 392.142 145.253 392.8 145.305C393.371 145.35 393.929 145.119 394.301 144.683C394.73 144.181 394.73 143.097 394.73 140.929V118.965Z"
      :stroke="color"
      stroke-width="7.15755"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M323.154 122.074C323.154 116.061 323.154 113.054 324.324 110.758C325.354 108.737 326.996 107.095 329.016 106.066C331.313 104.896 334.32 104.896 340.332 104.896H359.658C365.671 104.896 368.677 104.896 370.974 106.066C372.994 107.095 374.636 108.737 375.666 110.758C376.836 113.054 376.836 116.061 376.836 122.074V137.82C376.836 143.833 376.836 146.84 375.666 149.136C374.636 151.156 372.994 152.799 370.974 153.828C368.677 154.998 365.671 154.998 359.658 154.998H340.332C334.32 154.998 331.313 154.998 329.016 153.828C326.996 152.799 325.354 151.156 324.324 149.136C323.154 146.84 323.154 143.833 323.154 137.82V122.074Z"
      :stroke="color"
      stroke-width="7.15755"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#475467",
  },
});
</script>
